import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { ReturnNavState } from 'components/nav/return-nav-state';

export const L2Default = () => {
  const l2State = ReturnNavState.getL2Cookie();
  const path = l2State ? `/${l2State}` : '/welcome';
  return <Navigate to={path} replace />;
};
